// @ts-nocheck
import { Calendar, Plus } from 'lucide-react'
import DayScheduleRow from './DayScheduleRow'

const DAYS_OF_WEEK = [
  { key: 'monday', label: '月曜日' },
  { key: 'tuesday', label: '火曜日' },
  { key: 'wednesday', label: '水曜日' },
  { key: 'thursday', label: '木曜日' },
  { key: 'friday', label: '金曜日' },
  { key: 'saturday', label: '土曜日' },
  { key: 'sunday', label: '日曜日' },
]

export default function WeeklyScheduleEditor({ weeklyHours, onChange }) {
  // weeklyHoursがない場合はデフォルト値を使用
  const defaultWeeklyHours = {
    monday: { isOpen: true, hours: [{ start: '09:00', end: '18:00' }] },
    tuesday: { isOpen: true, hours: [{ start: '09:00', end: '18:00' }] },
    wednesday: { isOpen: true, hours: [{ start: '09:00', end: '18:00' }] },
    thursday: { isOpen: true, hours: [{ start: '09:00', end: '18:00' }] },
    friday: { isOpen: true, hours: [{ start: '09:00', end: '18:00' }] },
    saturday: { isOpen: false, hours: [] },
    sunday: { isOpen: false, hours: [] },
  }

  const currentWeeklyHours = weeklyHours || defaultWeeklyHours

  const handleDayChange = (dayKey, dayData) => {
    onChange({
      ...currentWeeklyHours,
      [dayKey]: dayData,
    })
  }

  const handleCopyToAll = (dayKey) => {
    if (confirm('この曜日の設定を全曜日にコピーしますか？')) {
      const sourceDay = currentWeeklyHours[dayKey]
      const newWeeklyHours = {}
      DAYS_OF_WEEK.forEach((day) => {
        newWeeklyHours[day.key] = {
          isOpen: sourceDay.isOpen,
          hours: JSON.parse(JSON.stringify(sourceDay.hours)), // ディープコピー
        }
      })
      onChange(newWeeklyHours)
    }
  }

  const handleSetWeekdays = () => {
    const newWeeklyHours = { ...currentWeeklyHours }
    // 平日を営業日に設定
    ;['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].forEach((day) => {
      newWeeklyHours[day] = {
        isOpen: true,
        hours: [{ start: '09:00', end: '18:00' }],
      }
    })
    // 土日を休業日に設定
    ;['saturday', 'sunday'].forEach((day) => {
      newWeeklyHours[day] = {
        isOpen: false,
        hours: [],
      }
    })
    onChange(newWeeklyHours)
  }

  const handleSet247 = () => {
    const newWeeklyHours = {}
    DAYS_OF_WEEK.forEach((day) => {
      newWeeklyHours[day.key] = {
        isOpen: true,
        hours: [{ start: '00:00', end: '23:59' }],
      }
    })
    onChange(newWeeklyHours)
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden">
      <div className="p-6 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-purple-100 dark:bg-purple-900/30 rounded-lg flex items-center justify-center">
              <Calendar className="w-5 h-5 text-purple-600 dark:text-purple-400" />
            </div>
            <div>
              <h3 className="text-md font-semibold text-gray-900 dark:text-white">曜日別営業時間</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                各曜日の営業時間を設定します
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleSetWeekdays}
              className="px-3 py-1.5 text-xs font-medium text-purple-700 dark:text-purple-300 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-colors"
            >
              平日9-18時
            </button>
            <button
              onClick={handleSet247}
              className="px-3 py-1.5 text-xs font-medium text-purple-700 dark:text-purple-300 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-colors"
            >
              24時間営業
            </button>
          </div>
        </div>
      </div>
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {DAYS_OF_WEEK.map((day) => (
          <DayScheduleRow
            key={day.key}
            dayKey={day.key}
            dayLabel={day.label}
            dayData={currentWeeklyHours[day.key]}
            onChange={(dayData) => handleDayChange(day.key, dayData)}
            onCopyToAll={() => handleCopyToAll(day.key)}
          />
        ))}
      </div>
    </div>
  )
}
